/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useObserver } from 'mobx-react';
import { useEnvStore } from '.';

function useSession() {
    const env = useEnvStore();
    const [session, setSession] = useState(env.session || null);
    const [initialized, setInitialized] = useState(!!env.observed.initialized);

    const signals = useObserver(() => ({
        initialized: env.observed.initialized,
        sessionExpired: env.observed.sessionExpired,
    }));

    // Only mark initialized once initApp() has actually completed
    useEffect(() => {
        if (!signals.initialized) return;
        setSession(env.session || null);
        setInitialized(true);
    }, [signals.initialized]);

    // Session expired mid-session — clear but stay initialized
    useEffect(() => {
        if (!signals.sessionExpired) return;
        setSession(null);
    }, [signals.sessionExpired]);

    return { session, isLoggedIn: !!session, initialized };
}

export default useSession;
